import { Injectable } from '@angular/core';
import { ReelCutting } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter, ConverterService } from '../../../../core/util';
import { UNIT_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class ReelCuttingNormalizer implements Converter<Occ.ReelCutting, ReelCutting> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.ReelCutting, target?: ReelCutting): ReelCutting {
    if (source) {
      target = this.convertReelCutting(source);
    }

    return target;
  }

  private convertReelCutting(source: Occ.ReelCutting): ReelCutting {
    if (source) {
      const { resultingUnit, resultingLength, ...target } = source;
      return {
        ...target,
        resultingLength: {
          value: source.resultingLength,
          unit: this.converter.convert(resultingUnit, UNIT_NORMALIZER),
        },
      };
    } else {
      return undefined;
    }
  }
}
